// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetSelfStudyResponseProgramOverviewHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import SelfStudyResponseProgramOverviewDTO from '../models/SelfStudyResponseProgramOverviewDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    id: string | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            id: '00000000-0000-0000-0000-000000000000',
        },
        initValues);
    },
    id: 'id',
}

interface Result extends ResultDTO {
    selfStudyResponseProgramOverview: SelfStudyResponseProgramOverviewDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            selfStudyResponseProgramOverview: null,
        },
        initValues);
    },
    selfStudyResponseProgramOverview: 'selfStudyResponseProgramOverview',
}

export { Request, Result };